import { validate } from '@krugom/validator';

const redirectTo = (arg?: any) => {
  const scheme = {
    type: 'string',
    required: true,
    pattern: /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^\s/$.?#].[^\s]*$/,
  };
  const result = validate(arg, scheme);

  if (!result.isValid) return;

  window.location.href = arg;
};

export default redirectTo;
